import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiTooltip from '@material-ui/core/Tooltip';
import { secondary1000 } from '../../../src/themes/colors';

const styles = () => ({
  tooltip: {
    minHeight: '1.75rem',
    padding: '0.313rem 0.5rem',
    borderRadius: '0.375rem',
    backgroundColor: secondary1000,
    lineHeight: '1.125rem',
  },
  arrow: {
    color: secondary1000,
  },
});

const Tooltip = (props) => {
  const { classes } = props;
  return (
    <MuiTooltip
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      arrow
      {...props}
    >
      {props.children}
    </MuiTooltip>
  );
};

export default withStyles(styles)(Tooltip);
